var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanvas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "canvas-icon",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.2 94.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.66,47A13.61,13.61,0,0,0,1.71,33.51a54.14,54.14,0,0,0,0,27A13.62,13.62,0,0,0,13.66,47Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.58,42.74A4.28,4.28,0,1,0,25.85,47v0A4.29,4.29,0,0,0,21.58,42.74Z",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M80.54,47A13.63,13.63,0,0,0,92.49,60.53a53.92,53.92,0,0,0,0-27A13.61,13.61,0,0,0,80.54,47Z",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M72.62,42.74A4.28,4.28,0,1,0,76.9,47v0A4.27,4.27,0,0,0,72.62,42.74Z",
    transform: "translate(0 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M47,80.58a13.61,13.61,0,0,0-13.5,12,54.14,54.14,0,0,0,27,0A13.61,13.61,0,0,0,47,80.58Z",
    transform: "translate(0 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M47,68.38a4.28,4.28,0,1,0,4.27,4.29h0A4.28,4.28,0,0,0,47,68.38Z",
    transform: "translate(0 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M47,13.66A13.6,13.6,0,0,0,60.52,1.71a54.14,54.14,0,0,0-27,0A13.61,13.61,0,0,0,47,13.66Z",
    transform: "translate(0 0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M47,17.31a4.27,4.27,0,1,0,4.27,4.27A4.27,4.27,0,0,0,47,17.31Z",
    transform: "translate(0 0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M70.7,70.7a13.63,13.63,0,0,0-1.11,18,54.1,54.1,0,0,0,19.1-19.1A13.63,13.63,0,0,0,70.7,70.7Z",
    transform: "translate(0 0)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M62.08,62.08a4.27,4.27,0,1,0,6,0l0,0A4.27,4.27,0,0,0,62.08,62.08Z",
    transform: "translate(0 0)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.4,23.4a13.61,13.61,0,0,0,1.11-18A54.15,54.15,0,0,0,5.41,24.52,13.61,13.61,0,0,0,23.4,23.4Z",
    transform: "translate(0 0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26,26a4.27,4.27,0,1,0,6,0l0,0A4.29,4.29,0,0,0,26,26Z",
    transform: "translate(0 0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M70.67,23.36a13.62,13.62,0,0,0,18,1.11,54.1,54.1,0,0,0-19.1-19.1A13.63,13.63,0,0,0,70.67,23.36Z",
    transform: "translate(0 0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M68.1,32a4.27,4.27,0,1,0-6,0l0,0A4.29,4.29,0,0,0,68.1,32Z",
    transform: "translate(0 0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.38,70.65a13.62,13.62,0,0,0-18-1.11,54.1,54.1,0,0,0,19.1,19.1A13.61,13.61,0,0,0,23.38,70.65Z",
    transform: "translate(0 0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26,62a4.27,4.27,0,1,0,6,0l0,0A4.29,4.29,0,0,0,26,62Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvas);
export default __webpack_public_path__ + "static/media/canvas.e1278db52a3fd052329b9d61f5b60c6a.svg";
export { ForwardRef as ReactComponent };